import { createFileRoute, redirect } from "@tanstack/react-router";

import { areaOf, meQuery } from "../shared/auth/me";

/** `/`: seller/admin → /app, owner → /portal, no session → /app/login (FE-01 §6.1). */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery).catch(() => null);
    if (!me) throw redirect({ to: "/app/login", replace: true });
    throw redirect({ to: areaOf(me) === "owner" ? "/portal" : "/app", replace: true });
  },
});
